export default __webpack_public_path__ + "static/neil-bitmoji-bc7731ce03863b5c8fd05188594c6f82.png";